import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import Icon from 'components/Icon';
import { getSelectedItem } from 'screens/SeriesDetail/SeriesDetailHelpers';

import Style from './Clips.module.scss';

const ClipsDropdown = ({
  clipsSections,
  isClipsPage = false,
  openDropdown,
  onDropdownOpen,
  onSelect = () => {},
}) => {
  const firstSectionName = _.get(clipsSections, '0.name', null);
  const selectedItem = getSelectedItem(clipsSections);

  const dropdownBackDrop = 'dropdown-backdrop';
  const handleOutsideClick = e => {
    if (e.target.id === dropdownBackDrop) {
      onDropdownOpen();
    }
  };

  const dropdownClass = openDropdown ? Style.active : null;

  const backdrop = openDropdown ? (
    <div className={Style.dropdownBackDrop} onClick={handleOutsideClick} id={dropdownBackDrop} />
  ) : null;

  if (clipsSections && clipsSections.length > 1) {
    const icon = openDropdown ? 'keyboard-arrow-up' : 'keyboard-arrow-down';
    return (
      <>
        <div>
          {backdrop}
          <span className={Style.seasonSelector} onClick={onDropdownOpen}>
            <span>{selectedItem.name}</span>
            <Icon icon={icon} color="white" size="large" viewBox="0 0 10 25" />
          </span>
          <ul className={classNames(Style.dropdownList, dropdownClass)}>
            {clipsSections &&
              clipsSections.map(item => (
                <li
                  className={Style.listItem}
                  key={`clips-${item.name}`}
                  onClick={() => onSelect(item)}
                >
                  {item.name}
                </li>
              ))}
          </ul>
        </div>
      </>
    );
  }
  return isClipsPage ? (
    <h1 className={Style.dropdownLabel}>{firstSectionName}</h1>
  ) : (
    <span className={Style.dropdownLabel}>{firstSectionName}</span>
  );
};

ClipsDropdown.propTypes = {
  clipsSections: PropTypes.arrayOf(PropTypes.shape([])).isRequired,
  isClipsPage: PropTypes.bool,
  openDropdown: PropTypes.bool,
  onDropdownOpen: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default ClipsDropdown;
